import { resolveVuetifyTheme } from '@core/utils/vuetify';
import { themeConfig } from '@themeConfig';

export const staticPrimaryColor = '#482BD9';

const theme = {
  defaultTheme: resolveVuetifyTheme(),
  themes: {
    light: {
      dark: false,
      colors: {
        primary:
          localStorage.getItem(`${themeConfig.app.title}-lightThemePrimaryColor`) ||
          staticPrimaryColor,
        'on-primary': '#482BD9',
        secondary: '#A8AAAE',
        'on-secondary': '#fff',
        success: '#28C76F',
        'on-success': '#fff',
        info: '#00CFE8',
        'on-info': '#fff',
        warning: '#FF9F43',
        'on-warning': '#fff',
        error: '#EA5455',
        background: '#FAF9FE',
        'surface-white-bg': '#fff',
        'card-background': '#fff',
        'sub-background': '#edeafb',
        'on-background': '#2F2B3D',
        'on-surface': '#2F2B3D',
        'grey-50': '#FAFAFA',
        'grey-100': '#F5F5F5',
        'grey-200': '#EEEEEE',
        'grey-300': '#E0E0E0',
        'grey-400': '#BDBDBD',
        'grey-500': '#9E9E9E',
        'grey-600': '#F2F2F7',
        'grey-700': '#616161',
        'grey-800': '#424242',
        'grey-900': '#212121',
        'perfect-scrollbar-thumb': '#DBDADE',
        'skin-bordered-background': '#fff',
        'skin-bordered-surface': '#fff',
        'light-purple': '#FAF9FE',
        'text-color': '#141414',
        'disabled-color': '#A19DB2',
        // aligned with --wp-text-tertiary (tokens.scss) for readable muted text
        'secondary-text-color': '#5F5D6D',
        'secondary-text-hover-color': '#A19DB2',
        'tertiary-text-color': '#A19DB2',
        'tertiary-color': '#6D56E0',
        'tertiary-icon-color': '#141414',
        'icon-primary': '#6E6B7D',
        'icon-accent': '#482BD9',
        'table-border': '#E8E8EC',
        'input-background': '#F6F5F8',
        bg: '#fff',
        'button-secondary-color': '#EDEAFB',
        'button-secondary-text-color': '#482BD9',
        'surface-tag': '#EDEAFB',
        'surface-tag-active': '#DAD5F7',
        'surface-tag-active2': '#DAD5F7',
        'surface-tag-hover-table': '#EDEAFB',
        'surface-input-popover': '#FAF9FE',
        'surface-surface-tag': '#EDEAFB',
        'surface-surface-card': '#EDEAFB',
        'surface-surface-card-chart': '#FAF9FE',
        'surface-surface-white': '#FFF',
        'button-hover-table': '#DAD5F7',
        'text-main-color': '#482BD9',
        'text-light-color': '#6D56E0',
        'icon-color': '#141414',
        'icon-gray': '#6E6B7D',
        'sun-background': '#FBEFEF',
        'borders-borders-light': '#F6F5F8',
        'borders-borders-button': '#E8E8EC',
        'borders-borders': '#E8E8EC',
        'surface-surface-tertiary': '#FAF9FE',
        'surface-surface-secondary': '#EDEAFB',
        'surface-surface-secondary-2': '#DAD5F7',
        'text-text-for-button': '#482BD9',
        'card-chart': '#FFF',
        'state-state-focus-drop-down': '#EDEAFB',
        'state-state-hover-drop-down': '#EDEAFB',
        'state-state-hover': '#6D56E0',
        'surface-surface-bg': '#FAF9FE',
        'state-state-disabled': '#DAD5F7',
        'surface-surface-card-2': '#FAF9FE',
        'surface-card-hover': '#EDEAFB',
        'surface-switch': '#EDEAFB',
        'surface-switch-hover': '#DAD5F7',
        'popup-primary': '#FFF',
        'borders-primary': '#E8E8EC',
        'empty-background-color': '#F6F5F8',
        'borders-tertiary': '#F6F5F8',
        'tag-tag-green': '#DEF6E4',
        'tag-tag-orange': '#FAF7E6',
        'tag-tag-red': '#FFEFF0',
        'popup-secondary': '#fff',
        'text-accent-main': '#482BD9',
        'state-main': '#482BD9',
        'surface-tertiary': '#FAF9FE',
        'borders-header-table': '#E8E8EC',
        'surface-calendar-selected-date': '#EDEAFB',
        'state-blur': '#FFFFFFB2',
        'surface-table-hover': '#DAD5F7',
        'state-pressed-open': '#2F12BF',
        'state-focus': '#A495EC',
        'text-secondary1': '#6E6B7D',
        'button-small': '#6D56E0',
        'surface-hover': '#EDEAFB',
        'text-for-tag': '#482BD9',
        'button-primary-text': '#482BD9',
        'surface-bg-icon': '#EDEAFB',
        'state-hover-table': '#DAD5F7',
        'constant-light-main-2': '#DAD5F7',
        'surface-filter': '#EDEAFB',
        'state-hover-tertiary': '#6D56E0',
        'surface-bulk-action': '#1B1928',
        'button-active-bg': '#2F2C40',
        'icon-muted': '#FFF',
        'borders-light-2': '#E8E8EC',
        'borders-button-active': '#2F2C40',
        'constant-white': '#FFF',
        'state-hover-balk': '#2F2C40',
        'surface-input-light': '#EDEAFB',
        'surface-table-header-hover': '#EDEAFB',
        'text-main-to-white': '#482BD9',
        'surface-badge-ma': '#FFFFFF',
        'tag-tag-violet-stroke': '#B6ABED',
        'tag-tag-violet': '#EDEAFB',
        'text-ma': '#151324',
        'borders-MA': '#2F2C40',
        'surface-badge-MA': '#2F2C40',
        'input-config-surface-tertiary': '#FAF9FE',
        'menu-icon-bg-disabled': '#F6F5F8',
        'state-hover-menu-2': '#DAD5F780',
        'state-hover-3': '#585567',
        'surface-chip': '#FFF',
        'border-header-table': '#E8E8EC',
      },
      variables: {
        'code-color': '#d400ff',
        'overlay-scrim-background': '#4C4E64',
        'tooltip-background': '#4A5072',
        'overlay-scrim-opacity': 0.5,
        'hover-opacity': 0.04,
        'focus-opacity': 0.12,
        'selected-opacity': 0.06,
        'activated-opacity': 0.16,
        'pressed-opacity': 0.14,
        'dragged-opacity': 0.1,
        'disabled-opacity': 0.42,
        'border-color': '#2F2B3D',
        'border-opacity': 0.16,
        'high-emphasis-opacity': 0.78,
        'medium-emphasis-opacity': 0.68,
        'switch-opacity': 0.2,
        'switch-disabled-track-opacity': 0.3,
        'switch-disabled-thumb-opacity': 0.4,
        'switch-checked-disabled-opacity': 0.3,

        // Shadows
        'shadow-key-umbra-color': '#2F2B3D',
      },
    },
    dark: {
      dark: true,
      colors: {
        primary:
          localStorage.getItem(`${themeConfig.app.title}-darkThemePrimaryColor`) ||
          staticPrimaryColor,
        'on-primary': '#482BD9',
        secondary: '#A8AAAE',
        'on-secondary': '#fff',
        success: '#28C76F',
        'on-success': '#fff',
        info: '#00CFE8',
        'on-info': '#fff',
        warning: '#FF9F43',
        'on-warning': '#fff',
        error: '#EA5455',
        background: '#151324',
        'surface-white-bg': '#151324',
        'card-background': '#1B1928',
        'sub-background': '#1B1928',
        'on-background': '#D0D4F1',
        surface: '#2F3349',
        'on-surface': '#D0D4F1',
        'grey-50': '#26293A',
        'grey-100': '#2F3349',
        'grey-200': '#26293A',
        'grey-300': '#4A5072',
        'grey-400': '#5E6692',
        'grey-500': '#7983BB',
        'grey-600': '#AAB3DE',
        'grey-700': '#B6BEE3',
        'grey-800': '#CFD3EC',
        'grey-900': '#E7E9F6',
        'perfect-scrollbar-thumb': '#4A5072',
        'skin-bordered-background': '#2f3349',
        'skin-bordered-surface': '#2f3349',
        'light-purple': '#2F2C40',
        'text-color': '#FFF',
        'disabled-color': '#585567',
        // aligned with --wp-text-tertiary (tokens.scss) for readable muted text
        'secondary-text-color': '#DAD5F7',
        'secondary-text-hover-color': '#FFF',
        'tertiary-text-color': '#A19DB2',
        'tertiary-color': '#DAD5F7',
        'tertiary-icon-color': '#A495EC',
        'icon-primary': '#fff',
        'icon-accent': '#A495EC',
        'table-border': '#494d64',
        'input-background': '#2f334a',
        bg: '#151324', // design-colors.md: surface/default dark
        'button-secondary-color': '#2F2C40',
        'button-secondary-text-color': '#FFF',
        'surface-tag': '#2F2C40',
        'surface-tag-active': '#585567',
        'surface-tag-active2': '#6D56E0',
        'surface-tag-hover-table': '#585567',
        'surface-input-popover': '#585567',
        'surface-surface-card': '#2F2C40',
        'surface-surface-card-chart': '#1B1928',
        'surface-surface-white': '#1B1928',
        'button-hover-table': '#2F2C40',
        'text-main-color': '#A495EC',
        'text-light-color': '#DAD5F7',
        'icon-color': '#A495EC',
        'icon-gray': '#A19DB2',
        'sun-background': '#151324',
        'borders-borders-light': '#2F2C40',
        'borders-borders-button': '#2F2C40',
        'borders-borders': '#585567',
        'surface-surface-tertiary': '#1B1928',
        'surface-surface-secondary': '#1B1928',
        'text-text-for-button': '#fff',
        'card-chart': '#2F2C40',
        'state-state-focus-drop-down': '#6E6B7D',
        'state-state-hover-drop-down': '#585567',
        'state-state-hover': '#A495EC',
        'surface-surface-bg': '#151324',
        'state-state-disabled': '#585567',
        'surface-surface-card-2': '#2F2C40',
        'surface-card-hover': '#151324',
        'surface-switch': '#151324',
        'surface-switch-hover': '#1B1928',
        'popup-primary': '#1B1928',
        'borders-primary': '#2F2C40',
        'borders-tertiary': '#2F2C40',
        'tag-tag-green': '#01A708',
        'tag-tag-orange': '#F8961E',
        'tag-tag-red': '#FF3F3F',
        'popup-secondary': '#2F2C40',
        'text-accent-main': '#A495EC',
        'state-main': '#6D56E0',
        'surface-tertiary': '#2F2C40',
        'borders-header-table': '#1B1928',
        'surface-calendar-selected-date': '#2F2C40',
        'state-blur': '#1B1928B2',
        'surface-table-hover': '#2F2C40',
        'state-pressed-open': '#DAD5F7',
        'state-focus': '#A495EC',
        'text-secondary1': '#E8E8EC',
        'button-small': '#DAD5F7',
        'surface-hover': '#2F2C40',
        'text-for-tag': '#fff',
        'button-primary-text': '#fff',
        'surface-bg-icon': '#151324',
        'state-hover-table': '#585567',
        'constant-light-main-2': '#A495EC',
        'surface-filter': '#2F2C40',
        'state-hover-tertiary': '#DAD5F7',
        'surface-bulk-action': '#585567',
        'button-active-bg': '#DAD5F7',
        'icon-muted': '#151324',
        'borders-light-2': '#585567',
        'borders-button-active': '#6E6B7D',
        'constant-white': '#FFF',
        'state-hover-balk': '#6E6B7D',
        'surface-input-light': '#585567',
        'surface-table-header-hover': '#585567',
        'text-main-to-white': '#FFF',
        'surface-badge-ma': '#1B1928',
        'tag-tag-violet-stroke': '#2F2C40',
        'tag-tag-violet': '#2F2C40',
        'text-ma': '#ffffff',
        'borders-MA': '#2F2C40',
        'surface-badge-MA': '#2F2C40',
        'input-config-surface-tertiary': '#2F2C40',
        'menu-icon-bg-disabled': '#2F2C40',
        'state-hover-menu-2': '#2F2C4066',
        'state-hover-3': '#585567',
        'surface-chip': '#6D56E0',
        'border-header-table': '#1B1928',
      },
      variables: {
        'code-color': '#d400ff',
        'overlay-scrim-background': '#101121',
        'tooltip-background': '#5E6692',
        'overlay-scrim-opacity': 0.6,
        'hover-opacity': 0.04,
        'focus-opacity': 0.12,
        'selected-opacity': 0.06,
        'activated-opacity': 0.16,
        'pressed-opacity': 0.14,
        'dragged-opacity': 0.1,
        'disabled-opacity': 0.42,
        'border-color': '#D0D4F1',
        'border-opacity': 0.16,
        'high-emphasis-opacity': 0.78,
        'medium-emphasis-opacity': 0.68,
        'switch-opacity': 0.4,
        'switch-disabled-track-opacity': 0.4,
        'switch-disabled-thumb-opacity': 0.8,
        'switch-checked-disabled-opacity': 0.3,

        // Shadows
        'shadow-key-umbra-color': '#0F1422',
      },
    },
  },
};

export default theme;
